import {
    CreativeDateRangeFilter,
    MediaDateRangeFilter
} from '~/report/data/ReportItemDefinitionTypes';
import {isBefore, now} from 'stringdate';

/** Checks if the passed in dates are within trial usage limits. if the passed in dates exceed the
 * earliest selectable date, we force the earliest date they can select to what we allow them to.
 * this is created so people don't modify URLs and try to query earlier dates than what the UI allows them */
export default function ensureDatesAreWithinTrialLimits(props: {
    originalDate?: MediaDateRangeFilter | CreativeDateRangeFilter;
    isTrialing: boolean;
    earliestSelectableDate: string;
}): MediaDateRangeFilter | CreativeDateRangeFilter | undefined {
    const {isTrialing, earliestSelectableDate, originalDate} = props;

    // don't do anything for people who aren't on a trial
    if (!isTrialing || !originalDate) return originalDate;

    // relative date handling
    if (originalDate.relative) {
        // this is just checking amount of months instead of checking against `earliestSelectableDate`.
        // if we ever add custom relative dates to the UI or if the requirements for `earliestSelectableDate` change,
        // this would need to be updated
        if (originalDate.relative.months > 1) {
            return {
                relative: {
                    months: 1,
                    ...('includeForecasted' in originalDate.relative && {
                        includeForecasted: originalDate.relative.includeForecasted
                    })
                }
            };
        }
    }

    // absolute date handling
    if (originalDate.absolute) {
        const {startDate, endDate} = originalDate.absolute;
        // if either the start or end date are before the allowed date, change it
        if (
            isBefore(earliestSelectableDate)(startDate) ||
            isBefore(earliestSelectableDate)(endDate)
        ) {
            return {absolute: {startDate: earliestSelectableDate, endDate: now()}};
        }
    }

    // dates are within allowed limits
    return originalDate;
}
